<template>
  <div>
    <vxe-grid
      ref="vxeGrid"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :loading="loading"
      :data="tableData"
      :columns="tableColumns"
      size="small"
      :height="300"
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="side-frame-success">
            <span style="font-size: 14px; color: #606266">{{
              $l('group_title_dep') || '部门执行统计'
            }}</span>
          </div>
        </slot>
      </template>
      <template v-slot:showBudget="{ row }">
        {{ row.v_annualBudget }}
      </template>
      <template v-slot:showSales="{ row }">
        {{ row.v_orderAmount }}
      </template>
      <template v-slot:rateOfProgress="{ row }">
        <div>
          <b-progress
            :variant="
              row.completionRate <= 20
                ? 'danger'
                : row.completionRate > 20 && row.completionRate <= 40
                ? 'warning'
                : row.completionRate > 40 && row.completionRate <= 60
                ? 'secondary'
                : row.completionRate > 60 && row.completionRate <= 80
                ? 'info'
                : row.completionRate > 80
                ? 'success'
                : ''
            "
            height="0.5rem"
            style="width: 200px"
            :value="row.completionRate"
            animated
          ></b-progress>
          <p style="font-size: 12px;margin:0px;">
            {{ $l('tips_input_rateOfProgress') || 'Completion' }}:
            {{ row.completionRate }}%
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  components: {},
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    tablePage: {
      default: null,
      type: Object
    },
    loading: {
      default: false
    },
    disabled: Boolean
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        },
        refresh: {
          query: () => this.$emit('reload')
        },
        zoom: true
      },
      tableColumns: tableColumns(this)
    }
  },
  methods: {}
}
</script>
